/** @format */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import {
  ActionIcon,
  Badge,
  Button,
  Pagination,
  Select,
  Skeleton,
  Table,
  Text,
  TextInput,
  Anchor,
  Modal,
} from "@mantine/core";
import { BeatLoader } from "react-spinners";
import { DatePicker } from "@mantine/dates";
import { Eye, Search } from "tabler-icons-react";
import { formatISO } from "date-fns";
import { useDebouncedValue } from "@mantine/hooks";
import { deleteAgreementBulk, getEmsignerLogs } from "../../utilities/apis/agreements";
import {
  getValueForInput,
  loadingStates,
  csvDownload,
  formatDate,
} from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";


const AgreementEmsignerLogModal =  (agreementId) => {
    

   
  const [open, setOpen] = useState(false);
   const [auditLogData, setAuditLogData] = useState(null);
   const [auditLogFile, setAuditLogFile] = useState('');

   useEffect(() => {
     const fetchAuditLog = async () => {
       try {
         const response = await apiWrapWithErrorWithData(
            getEmsignerLogs(agreementId)
         );
         
         if (response.success && response.logs.IsSuccess) {
           setAuditLogData(response.logs.Response[0].DocumentLogs);
           setAuditLogFile(response.logs.Response[0].DocumentName);
         }
       } catch (error) {
         console.error("Error fetching audit log:", error);
       }
     };

     fetchAuditLog();
   }, [agreementId]);
  

 
  return (
    <>
      <div className="flex flex-col">
        <div className="flex justify-between my-4">
          <Text>Emsigner Audit Log-  {auditLogFile}</Text>
        </div>
      </div>

      <br />

      {!auditLogData && (
        <div className="flex flex-col">
          {Array.from({ length: 10 }).map((i) => (
            <Skeleton key={i} height={30} radius="md" className="my-1 w-full" />
          ))}
          <div className="flex flex-row justify-center">
            <Skeleton height={40} radius="md" className="w-40" />
          </div>
        </div>
      )}
      {auditLogData && (
        <div className="flex flex-col">
          <Table striped>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Last Action</th>
                <th>Last Action By User</th>
                <th>DateTime</th>
              </tr>
            </thead>
            <tbody>
              {auditLogData.map((log, index) => (
                <tr key={log.id}>
                  <td>{index + 1}</td>
                  <td>{log.Action}</td>
                  <td>{log.UserEmail}</td>
                  <td>{formatDate(log.DateTime)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    
     
    </>
  );
};

export default AgreementEmsignerLogModal;
